module.exports = __webpack_public_path__ + "static/media/F-1.93f1bf7f.webp";